// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const McpConsentOut = zod.object({
  "client_name": zod.string(),
  "defaults": zod.array(zod.string()),
  "loopback": zod.boolean(),
  "max_days": zod.int(),
  "redirect_uri": zod.string(),
  "scopes": zod.array(zod.string()),
  "tool_name": zod.string()
});

export type McpConsentOut = zod.input<typeof McpConsentOut>;
export type McpConsentOutOutput = zod.output<typeof McpConsentOut>;
